export default {
  'pages.cart.title': 'Shopping Cart',
  'pages.cart.table.header.info': 'Goods Info',
  'pages.cart.table.header.values': 'Custom Craft',
  'pages.cart.table.header.color': 'Custom Color',
  'pages.cart.table.header.quantity': 'Quantity',
  'pages.cart.table.header.action': 'Action',
  'pages.cart.table.checkAll': 'Check All',
  'pages.cart.table.delete': 'Delete',
  'pages.cart.table.total': 'Total:',
  'pages.cart.table.unit.single': 'item',
  'pages.cart.table.unit.plural': 'items',
  'pages.cart.table.btn.submit': 'Submit',
  'pages.cart.table.deleteTip.single': 'Do you want to remove this item?',
  'pages.cart.table.deleteTip.plural': 'Do you want to remove these item?',
  'pages.cart.submit.success.title': 'Success',
  'pages.cart.submit.success.content': 'Success to submit!',
  'pages.cart.submit.success.okBtn': 'Online Service',
  'pages.cart.submit.success.cancelBtn': 'Detail',
  'pages.cart.submit.error.title': 'Error',
  'pages.cart.submit.error.content': 'Please contact online service!',
  'pages.cart.submit.error.okBtn': 'Online Service',
};
